/*
 *=========================================================================================
 *File Name: mutations.js
 *Description: Vuex Store - mutations
 *----------------------------------------------------------------------------------------
 *Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
 *Author: Pixinvent
 *Author URL: http://www.themeforest.net/user/pixinvent
 *==========================================================================================
 */

import VueCookies from "vue-cookies";

const mutations = {
	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////

	// Vertical NavMenu

	TOGGLE_IS_CONTRACT_POPUP(state, value) {
		state.isContractPopUp= value;
	},
	TOGGLE_IS_NOTIF_POPUP(state, value) {
		state.isNotifPopUp = value;
	},
	TOGGLE_FLEXIBLE_POPUP(state, value) {
		if (typeof value === 'object') {
			state.showFlexiblePopup = value.active;
			state.flexiblePopupContractId = value.contractId || null;
			state.flexiblePopupLeadConsultantId = value.leadConsultantId || null;
		} else {
			// Backward compatibility for boolean values
			state.showFlexiblePopup = value;
			state.flexiblePopupContractId = null;
			state.flexiblePopupLeadConsultantId = null;
		}
	},
	UPDATE_NOTE_COMMERCIAL(state, value) {
		state.noteCommerical = value;
	},
	TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
		state.isVerticalNavMenuActive = value;
	},
	TOGGLE_REDUCE_BUTTON(state, val) {
		state.reduceButton = val;
	},
	UPDATE_MAIN_LAYOUT_TYPE(state, val) {
		state.mainLayoutType = val;
	},
	UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
		state.verticalNavMenuItemsMin = val;
	},
	UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
		state.verticalNavMenuWidth = width;
	},
	UPDATE_RELANCE_FILTER(state, val) {
		state.relanceFilter = val;
	},

	// VxAutoSuggest

	UPDATE_STARRED_PAGE(state, payload) {
		// find item index in search list state
		const index = state.navbarSearchAndPinList["pages"].data.findIndex(
			item => item.url == payload.url
		);

		// update the main list
		state.navbarSearchAndPinList["pages"].data[index].is_bookmarked =
      payload.val;

		// if val is true add it to starred else remove
		if(payload.val) {
			state.starredPages.push(
				state.navbarSearchAndPinList["pages"].data[index]
			);
		}
		else{
			// find item index from starred pages
			const index = state.starredPages.findIndex(
				item => item.url == payload.url
			);

			// remove item using index
			state.starredPages.splice(index, 1);
		}
	},

	// Navbar-Vertical

	ARRANGE_STARRED_PAGES_LIMITED(state, list) {
		const starredPagesMore = state.starredPages.slice(10);
		state.starredPages = list.concat(starredPagesMore);
	},
	ARRANGE_STARRED_PAGES_MORE(state, list) {
		let downToUp = false;
		let lastItemInStarredLimited = state.starredPages[10];
		const starredPagesLimited = state.starredPages.slice(0, 10);
		state.starredPages = starredPagesLimited.concat(list);

		state.starredPages.slice(0, 10).map(i => {
			if(list.indexOf(i) > -1) downToUp = true;
		});

		if(!downToUp) {
			state.starredPages.splice(10, 0, lastItemInStarredLimited);
		}
	},

	// ////////////////////////////////////////////
	// UI
	// ////////////////////////////////////////////

	TOGGLE_CONTENT_OVERLAY(state, val) {
		state.bodyOverlay = val;
	},
	UPDATE_PRIMARY_COLOR(state, val) {
		state.themePrimaryColor = val;
	},
	UPDATE_THEME(state, val) {
		state.theme = val;
	},
	UPDATE_WINDOW_WIDTH(state, width) {
		state.windowWidth = width;
	},
	UPDATE_WINDOW_HEIGHT(state, height) {
		state.windowHeigth = height;
	},
	UPDATE_FILTER_CARD_HEIGHT(state, height) {
		state.filterCardHeight = height;
	},
	UPDATE_HORIZENTAL_NAVBAR_HEIGHT(state, height) {
		state.horizentalNavBarHeight = height;
	},
	UPDATE_WINDOW_SCROLL_Y(state, val) {
		state.scrollY = val;
	},
	UPDATE_TABLE_HEIGHT(state, val){
		state.tableHeight = val;
	},
	UPDATE_FILTER_DOWN(state, val){
		state.isFilterDown = val;
	},

	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////

	// Updates user info in state and sessionStorage
	UPDATE_USER_INFO(state, payload) {
		// Get Data sessionStorage
		let userInfo = VueCookies.get("userInfo") || state.activeUser;
		for(const property of Object.keys(payload)) {
			if(payload[property] != null) {
				// If some of user property is null - user default property defined in state.activeUser
				state.activeUser[property] = payload[property];

				// Update key in sessionStorage
				userInfo[property] = payload[property];
			}
		}
		// Store data in sessionStorage
		VueCookies.set("userInfo", JSON.stringify(userInfo), "1y");
	},
	////
	//Commade
	////
	DELETE_USER_COMMANDES(state, data) {
		let item = state.commandes.find((i) => i.id === data.id);
		//console.log("hohohoh");
		//console.log(state.commandes);
		if(item) {
			state.commandes = state.commandes.filter((i) => i.id !== data.id);
		}
		//console.log(state.commandes);
	},

	SET_CUSTOMERS: (state, data) => (state.customers = data),
	SET_FLEXIBLE_MISSIONS: (state, data) => (state.flexibleMissions = data.reverse()),
	SET_CONTENT_PRODUCT: (state, data) => (state.contentProducts = data),
	SET_REDAC_LANG: (state, data) => (state.redac_lang = data),

	// Update the societies state
	SET_STAT_DATE_FILTER: (state, data) => (state.statDateFilter = data),

	// Update the societies state
	SET_SELECTED_SOCIETY: (state, data) => (state.activeUserSociety = data),

	// Update the societies state
	SET_SOCIETIES: (state, data) => {
		state.societies = data;
		state.societiesOption = [{"id": 9999999999, "name": "Ajouter nouveau client"}].concat(data);
	},

	SET_SOCIETIES_TAGS: (state, data) => (state.societies_tags = data),

	// Update the contracts state
	SET_CONTRACTS: (state, data) => (state.contracts = data),

	// Update the contracts_users state
	SET_CONTRACTS_USERS: (state, data) => (state.contracts_users = data),

	// Update the contracts_contracts_users state
	SET_CONTRACTS_CONTRACTS_USERS: (state, data) => (state.contracts_contracts_users = data),

	SET_CONTRACTS_DOCUMENTS_TYPES: (state, data) => (state.contracts_documents_types = data),

	SET_COUNTRIES: (state, data) => (state.countries = data),

	SET_NOTIFICATIONS: (state, data) => (state.notifications = data),
	SET_NOTIFICATIONS_TYPES: (state, data) => (state.notifications_types = data),

	// Update the providers state
	SET_PROVIDERS: (state, data) => (state.providers = data),

	SET_PROVIDERS_TAGS: (state, data) => (state.providers_tags = data),

	// Update the providers state
	SET_PROSPECTS_SEARCHES: (state, data) => (state.ps = data),
	SET_PROSPECTS_PROJECTS: (state, data) => (state.prospects_projects = data),
	SET_NEW_PROSPECTS: (state, data) => (state.newProspects = data),
	SET_OLD_PROSPECTS: (state, data) => (state.oldProspects = data),
	SET_KEYWORD_LIST_BY_AI: (state, data) => (state.keywordListByAi = data),

	// Update the services state
	SET_SERVICES: (state, data) => (state.services = data),

	// Update the contacts state
	SET_CONTACTS: (state, data) => (state.contacts = data),

	// Update the collaborators state
	SET_COLLABORATORS: (state, data) => (state.collaborators = data),

	// Update the collaborators avatar state
	SET_COLLABORATORS_AVATAR: (state, data) => (state.collaborators_avatar = data),

	// Update the products state
	SET_PRODUCTS: (state, data) => (state.products = data),

	// Update the products state
	SET_PRODUCTS_CATEGORIES: (state, data) => (state.products_categories = data),

	// Update the products state
	SET_PRODUCTS_SUB_CATEGORIES: (state, data) => (state.products_sub_categories = data),

	// Update the purchases state
	SET_PURCHASES: (state, data) => (state.purchases = data),
	SET_NETLINK_THEMAS: (state, data) => (state.netlinkThemas = data),
	SET_NETLINK_INTL: (state, data) => (state.netlinkIntl = data),
	SET_ALL_ORDERS: (state, data) => (state.allOrderList = data),

	// Update the reports state
	SET_REPORTS: (state, data) => (state.reports = data),

	// Update the dns state
	SET_DNS: (state, data) => (state.dns = data),

	// Update the missions state
	SET_MISSIONS: (state, data) => (state.missions = data),

	// Update the netlink state
	SET_NETLINK: (state, data) => (state.netlink = data),

	// Update the netlink state
	SET_NETLINK_TYPES: (state, data) => (state.netlink_types = data),

	// Update the users state
	SET_USERS: (state, data) => (state.users = data),

	// Update the users state
	SET_USERS_SOCIETIES: (state, data) => (state.users_societies = data),

	// Update the task state
	SET_TASKS: (state, data) => (state.tasks = data),
	SET_CONTRACT_TASKS: (state, data) => (state.thisContractTasks = data),

	// Update the term state
	SET_TERMS: (state, data) => (state.terms = data),

	// Update the tva_ids state
	SET_TVA_IDS: (state, data) => (state.tva_ids = data),

	// Update the privous society selected (currently used in statistic pages)
	SET_PREVIOUS_SOCIETY: (state, data) => (state.previousSociety = data),

	// Update the documentType state
	SET_DOC_TYPE: (state, data) => (state.docTypeList = data),

	//UserCommande
	SET_COMMANDES: (state, data) => (state.commandes = data),

	//editing userCommandeBtn
	SET_EDIT_COMMANDES_BTN: (state, data) => (state.isEditCommandebtn = data),

	TOOGLE_NEW_COMMANDE_POP: (state, data) => {
		state.showAddNewCommandePopup = data;
	},
	//filters
	SET_FILTER_FIELDS: (state, data) => (state.filterFields = data),
	SET_ROW_NUM: (state, data) => (state.filterRowNum = data),
	//personal_notification
	SET_PERSONAL_NOTIFICATION: (state, data) => (state.personalNotification = data),
	TRRIGER_CLICK_EVENTS: (store1) => (store1.plugins[0].triggerClickEvent()),

	// Google Ads 
	SET_GOOGLE_ADS: (state, data) => (state.googleAds = data),

	// keywords
	SET_KEYWORD_CATEGORIES: (state, data) => (state.keywordsCategories = data),

	// Backlinks selection mutations
	ADD_BACKLINK_SELECTION: (state, itemId) => {
		if (!state.backlinksSelectedIds.includes(itemId)) {
			state.backlinksSelectedIds.push(itemId);
		}
	},
	REMOVE_BACKLINK_SELECTION: (state, itemId) => {
		const index = state.backlinksSelectedIds.indexOf(itemId);
		if (index > -1) {
			state.backlinksSelectedIds.splice(index, 1);
		}
	},
	SET_BACKLINKS_CURRENT_PAGE_SELECTED: (state, items) => {
		state.backlinksCurrentPageSelected = items;
	},
	CLEAR_ALL_BACKLINKS_SELECTIONS: (state) => {
		state.backlinksSelectedIds = [];
		state.backlinksCurrentPageSelected = [];
	},
	SYNC_BACKLINKS_SELECTIONS: (state, items) => {
		// Clear old selections from current page items and add new ones
		items.forEach(item => {
			if (state.backlinksCurrentPageSelected.find(selected => selected.id === item.id)) {
				if (!state.backlinksSelectedIds.includes(item.id)) {
					state.backlinksSelectedIds.push(item.id);
				}
			} else {
				const index = state.backlinksSelectedIds.indexOf(item.id);
				if (index > -1) {
					state.backlinksSelectedIds.splice(index, 1);
				}
			}
		});
	},
};

export default mutations;
